export const NDF_FORM_MAX_DATERANGE_DAYS_DIFFERENCE = 90;

export const NDF_ERP_ENDPOINT = '/v1/ndf/erp';
export const NDF_HBR_ENDPOINT = '/v1/ndf/hbr';
